import React  from "react";
import { Helmet } from "react-helmet";
import useWebsiteSetting from "../FetchAPI";


export default function PrivacyPolicy() {

    const [webSetting] = useWebsiteSetting();

  return (
    <>
      <Helmet>
        <title>Privacy Policy</title>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
  

  <section className="gazette-hero">
        <div className="hero-shape shape1"></div>
        <div className="hero-shape shape2"></div>

        <div className="container">
          <div className="row">
            <div className='col-lg-12'>
              <div className="hero-contenttitle text-center">
                <span className="hero-badge">Privacy Policy</span>
                <h1 className="hero-contenttitleh1">Privacy Policy</h1>
              </div>
            </div>

              <div className="col-lg-12">
              <div className="hero-content">

                <div
                        className="post-content entry-content"
                        dangerouslySetInnerHTML={{
                          __html: webSetting.privacy_policy_desc,
                        }}
                      ></div>


              </div>

            </div>

          </div>


        </div>
      </section>



    </>
  );
}
